import apiManager from '@/services/API/apiManager'

const completeJob = async (queryObj) => {
	const formData = new FormData()
	apiManager.axios.defaults.timeout = 20000
	apiManager.axios.defaults.headers.post['Content-Type'] = 'multipart/form-data'
	queryObj.images.forEach((image) => {
		formData.append('images', image)
	})
	queryObj.files.forEach((document) => {
		formData.append('files', document)
	})
	formData.append('agentRemark', queryObj.agentRemark)
	formData.append('status', queryObj.status)
	const newJobStatus = await apiManager.axios
		.patch(
			`/v1/admin/incident/${queryObj.incidenceId}/job/${queryObj.jobId}`,
			formData
		)
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})
	return newJobStatus
}

const deleteJobPhoto = async (incidentId, jobId, photoId) => {
	const deletePhoto = await apiManager.axios
		.delete(`/v1/admin/incident/${incidentId}/job/${jobId}/photo/${photoId}`)
		.then((response) => {
			return { status: 200, data: response.data }
		})
		.catch((err) => {
			return {
				status: err.response.status,
			}
		})

	return deletePhoto
}

export default {
	completeJob,
	deleteJobPhoto,
}
